import 'reflect-metadata';

export * from './index.auto';
